import { render, staticRenderFns } from "./ReportsQS.vue?vue&type=template&id=b6a99dd2&scoped=true"
import script from "./ReportsQS.vue?vue&type=script&lang=ts"
export * from "./ReportsQS.vue?vue&type=script&lang=ts"
import style0 from "./ReportsQS.vue?vue&type=style&index=0&id=b6a99dd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6a99dd2",
  null
  
)

export default component.exports